import { render, staticRenderFns } from "./client-info-edit-tab.vue?vue&type=template&id=64af9be8&scoped=true"
import script from "./client-info-edit-tab.vue?vue&type=script&lang=js"
export * from "./client-info-edit-tab.vue?vue&type=script&lang=js"
import style0 from "./client-info-edit-tab.vue?vue&type=style&index=0&id=64af9be8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64af9be8",
  null
  
)

export default component.exports